<template>
  <div  class="home">
    <wx-open-launch-weapp
        id="launch-btn"
        :username="username"
        :path="path"
        @launch="handleLaunchFn"
        @error="handleErrorFn"
    >
      <script type="text/wxtag-template">
        <style>.btn { display: flex;align-items: center;width: 200px;height: 200px }</style>
        <button class="btn">点击进入小程序</button>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>
<script>
import basicsMixinx from 'mixins/basics'
export default {
  mixins:[basicsMixinx],
  data () {
    return {
      username:"gh_10015f7c55a5",
      path:"pages/home/index"
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleLaunchFn (e) {
      console.log(e)
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
  }
}
</script>



// WEBPACK FOOTER //
// littleAssistant.vue?0192903f